export const EQUIPT_MENU_ID = 'equipt';

/**
 * POMWIN-38700 - equipt.netxinvestor.com and osaic.netxinvestor.com are consolidated into
 * osaic.netxinvestor.com. The equipt menu is hidden in the menu configuration and is only
 * enabled for legacy Equipt investors (isNewEquipt is false in appSettings) who land on the
 * site through SSO.
 */
export function isEquiptMenuEnabled(appSettings: any): boolean {
    return appSettings?.isNewEquipt !== true && appSettings?.isVendorSso === true;
}

/**
 * Un-hides the equipt menu item when the equipt menu is enabled. The menu configuration is
 * left untouched for every other scenario.
 */
export function enableEquiptMenuItems(menuItems: any[], equiptMenuEnabled: boolean): any[] {
    if (!equiptMenuEnabled || !Array.isArray(menuItems) || menuItems.length === 0) {
        return menuItems;
    }
    menuItems.forEach(menuItem => {
        if (menuItem && menuItem.id === EQUIPT_MENU_ID) {
            menuItem.hideFromNavigation = false;
        }
    });
    return menuItems;
}
